import React from 'react';
import "react-lightbox-pack/dist/index.css";
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');
// 

var _ = require('lodash');

export default function EventDate({ event }) {
	const sameDay = (start, end) => {
		var mstart = dayjs(start);
		var mend = dayjs(end);
		var year1 = mstart.year(), month1 = mstart.month(), day1 = mstart.date();
		var day1n = mstart.add(24, 'hour')
		var year2 = mend.year(), month2 = mend.month(), day2 = mend.date();
		var hour2 = mend.hour();
		if (year1 == year2 && month1 == month2 && ((day2 == day1) || (day2 == day1n && hour2 < 8))) {
			return true
		}
		return false
	};
	return (<div style={{
		backgroundColor: "#eaeaea",
		fontSize: "16px",
		fontWeight: "400",
		color: "black",
		borderRadius: "6px",
		textAlign: "center",
		padding: "0 7px",
		textAlign: "center",
	}}>
		<div style={{
			borderRadius: "5px",
			backgroundColor: "#f6214b",
			fontSize: "12px",
			fontWeight: "600",
			color: "white",
			margin: "0 -7px",
			boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
			padding: "3px 7px"
		}}>
			{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
			{/* {true === sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) &&
				dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')
			} */}
			{/* {true !== sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) &&
				<>
					<div style={{ fontSize: "16px" }}>
						{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD')}
						-
						{dayjs(event.okonchanieSorevnovaniya).tz("Europe/Moscow").format('DD')}
					</div>
					<div style={{ fontSize: "14px" }}>
						{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('MMMM')} {dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('YYYY')}
					</div>
				</>
			} */}
		</div>
		<div style={{
			fontSize: "10px",
			fontWeight: "400",
			padding: "0px"
		}}>
			{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
			{/* {true === sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) && <>
				{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
			</>}
			{true !== sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) && <>
				{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
				<span> - </span>
				{dayjs(event.okonchanieSorevnovaniya).tz("Europe/Moscow").format('dddd')}
			</>} */}
		</div>
	</div>);
};